import { bindActionCreators } from '@reduxjs/toolkit'
import { useMemo } from 'react'
import type { TypedUseSelectorHook } from 'react-redux'
import { useDispatch, useSelector } from 'react-redux'
import type { AppDispatch, RootState } from './store'

import { getAssessmentById } from './slice/assesment.slice'
import { getCareTeamById } from './slice/care-teams.slice'
import { getCertificates } from './slice/certificates.slice'
import { changeStatus, getTopics, getTopicsInReview } from './slice/learn-library.slice'
import { getProgressResultsById } from './slice/progress-results.slice'
import { getSharedTimelineSilent } from './slice/sharedTimeline.slice'
import { getTimelineById, getTimelineSilent } from './slice/timeline.slice'
import { logout, signIn, updateCarePerson, updateProfile } from './slice/user.slice'
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

const rootActions = {
  getTimelineById,
  getTimelineSilent,
  getSharedTimelineSilent,
  getCareTeamById,
  getAssessmentById,
  getProgressResultsById,
  signIn,
  logout,
  updateProfile,
  getTopics,
  getTopicsInReview,
  updateCarePerson,
  learnLibraryChangeStatus: changeStatus,
  getCertificates,
}

export const useActions = () => {
  const dispatch = useDispatch()

  return useMemo(() => bindActionCreators(rootActions, dispatch), [dispatch])
}
